export default __webpack_public_path__ + "static/Lamborn-hill-Home-page-video-64d2d03b89ac8b77aa24df97d401eda9.mp4";